import { GREAT_ADJECTIVE_WORD } from '@glass/common/modules/content/staticVariations/adjectiveWords/adjectiveWordVariations';

const adjectiveAlternativeVariations = ['school', 'college', GREAT_ADJECTIVE_WORD];

export default adjectiveAlternativeVariations;
